import React, { PropsWithChildren, ReactNode } from 'react';

import styled from '@emotion/styled';
import MuiTooltip, {
  tooltipClasses,
  TooltipProps as MuiTooltipProps,
} from '@mui/material/Tooltip';

const StyledTooltip = styled(({ className, ...props }: MuiTooltipProps) => (
  <MuiTooltip {...props} classes={{ tooltip: className, arrow: className }} />
))`
  &.${tooltipClasses.tooltip} {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.tooltip.container.itemSpacing};
    border-radius: ${({ theme }) => theme.tooltip.container.borderRadius};
    box-shadow: ${({ theme }) => theme.tooltip.container.boxShadow};
    padding-inline: ${({ theme }) => theme.tooltip.container.horizontalPadding};
    padding-block: ${({ theme }) => theme.tooltip.container.verticalPadding};
    background: ${({ theme }) => theme.tooltip.container.fill};
  }
`;

const Content = styled.div`
  color: ${({ theme }) => theme.tooltip.label.fill};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.tooltip.label.fontSizes};
  line-height: ${({ theme }) => theme.tooltip.label.lineHeights};
  text-transform: ${({ theme }) => theme.tooltip.label.textCase};
  letter-spacing: ${({ theme }) => theme.tooltip.label.letterSpacing};
`;

export interface ITooltipProps
  extends Omit<MuiTooltipProps, 'content' | 'title' | 'followCursor'> {
  content: ReactNode;
  followCursor?: boolean;
  disabled?: boolean;
}

export const Tooltip = ({
  content,
  disabled,
  followCursor = true,
  ...baseProps
}: PropsWithChildren<ITooltipProps>) => (
  <StyledTooltip
    title={<Content>{content}</Content>}
    enterTouchDelay={0}
    onClick={(event) => event.stopPropagation()}
    disableFocusListener={disabled}
    disableHoverListener={disabled}
    disableTouchListener={disabled}
    followCursor={followCursor}
    {...baseProps}
  />
);
